import { formatTierRange } from "./formatters";
function mapContractTiers(tiers, unitOfMeasure) {
    return tiers.map((tier, index)=>{
        const min = tier.min_inclusive ?? 0;
        const max = tier.max_exclusive;
        return {
            tier: `Tier ${index + 1}`,
            range: formatTierRange(min, max, unitOfMeasure),
            price: tier.monthly_fee,
            min_inclusive: tier.min_inclusive,
            max_exclusive: tier.max_exclusive
        };
    });
}
function mapPricingPolicyTiers(tiers, unitOfMeasure) {
    return tiers.map((tier, index)=>{
        const min = tier.min_inclusive ?? 0;
        const max = tier.max_exclusive;
        return {
            tier: tier.label || `Tier ${index + 1}`,
            range: formatTierRange(min, max, unitOfMeasure),
            price: tier.monthly_fee,
            min_inclusive: tier.min_inclusive,
            max_exclusive: tier.max_exclusive
        };
    });
}
export function transformPricingTiers({ contractTiers, pricingPolicyTiers, unitOfMeasure }) {
    if (contractTiers && contractTiers.length > 0) {
        return mapContractTiers(contractTiers, unitOfMeasure);
    }
    if (pricingPolicyTiers && pricingPolicyTiers.length > 0) {
        return mapPricingPolicyTiers(pricingPolicyTiers, unitOfMeasure);
    }
    return [];
}
